/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetQppSysReserveUrl$Params {}

export function getQppSysReserveUrl(
  http: HttpClient,
  rootUrl: string,
  params?: GetQppSysReserveUrl$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getQppSysReserveUrl.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'text', accept: 'text/plain', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    }),
  );
}

getQppSysReserveUrl.PATH = '/service/v1/url/getQPPSysReserveUrl';
